// Spacing values defined in variable units (rem)
export default [0, 0.5, 1, 2, 4, 8];
